// src/js/components/Shared/ImportWizard/components/DefaultRule.jsx
import React, { useState, useCallback } from "react";
import {
  ListItem,
  ListItemText,
  Grid,
  TextField,
  IconButton
} from "@material-ui/core";
import LabeledAutocomplete from "js/components/Shared/Form/Fields/LabeledAutocomplete";
import DeleteIcon from "@material-ui/icons/Delete";

export default React.memo(function DefaultRule({
  suggestions,
  onRemove,
  id,
  estado,
  onUpdate
}) {
  /* ---------- 1️⃣  Estado local (solo salida) -------------- */
  const [salida, setSalida] = useState((estado && estado.salida) || null);

  /* ---------- 2️⃣  Cambio de salida – actualiza el estado externo ----------
     Se hace directamente para evitar un useEffect infinito.         */
  const handleSalidaChange = useCallback(
    value => {
      setSalida(value);
      const newEstado = {
        ...estado,
        salida: value
      };
      onUpdate(newEstado, id);
    },
    [estado, id, onUpdate]
  );

  const handleSalidaInputChange = useCallback(
    e => handleSalidaChange(e.target.value),
    [handleSalidaChange]
  );

  /* ---------- 3️⃣  Eliminación --------------------------------------- */
  const handleRemove = useCallback(() => onRemove(id), [onRemove, id]);

  /* ---------- 4️⃣  Render ------------------------------------------- */
  return (
    <ListItem
      style={{ marginTop: "1%", alignItems: "flex-start", padding: "0%" }}
    >
      <ListItemText
        primary="Valor por defecto →"
        secondary={
          <Grid container alignItems="center" spacing={8}>
            <Grid item xs={8}>
              {suggestions.length > 0 ? (
                <LabeledAutocomplete
                  label="Elementos"
                  isDisabled={false}
                  noOptionsMessage={() => "No se encontraron elementos"}
                  placeholder="Seleccione un elemento"
                  suggestions={suggestions}
                  value={salida || null}
                  onChange={handleSalidaChange}
                />
              ) : (
                <TextField
                  placeholder="Segmento 1"
                  value={salida || ""}
                  onChange={handleSalidaInputChange}
                  label="Salida"
                  style={{ width: "100%" }}
                />
              )}
            </Grid>
            <Grid item xs={2}>
              <IconButton aria-label="Borrar" onClick={handleRemove}>
                <DeleteIcon />
              </IconButton>
            </Grid>
          </Grid>
        }
      />
    </ListItem>
  );
});
